module.exports = __webpack_public_path__ + "static/media/icn_phone.8d8825ea.svg";